/**
 * One uploaded line → the row the enquiry takes (2026-09-18).
 *
 * `uom` is mandatory on `Enquiry Item` and a Link, so a line can be sent neither without a unit
 * nor with one the master lacks. The mail path has handled both since August
 * (`createEnquiryLines.ts`): a placeholder unit, and the line left UNMATCHED so the substitution
 * cannot hide inside a finished-looking row — a human confirms the unit before it reaches a
 * supplier. The upload path sent `null` and the whole write failed on a requisition form with
 * no Unit column ("Row #7: Value missing for: UOM").
 *
 * The customer's own word, when they wrote one the master does not spell, stays on the wording
 * in the same `(customer's unit: …)` form the mail path uses, which the row's hint reads back.
 */

import { PLACEHOLDER_UOM } from '../features/mail/createEnquiryLines'
import type { SheetItem } from './sheetExtract'
import type { NewEnquiryItem } from './types'
import { resolveUom } from './uom'

export function uploadLine(item: SheetItem, master: readonly string[]): { add: NewEnquiryItem; unknownUnit: string | null } {
  const unit = resolveUom(item.uom, master)
  if (unit) {
    return { add: { item_code: item.item_code, qty: item.qty, uom: unit, customer_uom: unit, raw_text: item.description }, unknownUnit: null }
  }
  const written = (item.uom ?? '').trim()
  return {
    add: {
      // Unmatched on purpose: 3 "Nos" of something asked in drums is a quantity error with money
      // attached, and only a person can say what the unit should be.
      item_code: null,
      qty: item.qty,
      uom: PLACEHOLDER_UOM,
      raw_text: written ? `${item.description} (customer's unit: ${written})` : item.description,
    },
    unknownUnit: written || null,
  }
}
